import { Component, OnInit } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { ServiceService } from '../service.service';
import { ApiService } from '../core/api.service';
import { endPoints } from '../core/Apis/apiEndpoints';
import { formatDate } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonFunctionsService } from '../functions/common-functions.service';
import { log } from 'node:console';
import * as moment from 'moment';
import { Router, NavigationStart } from '@angular/router';

@Component({
  selector: 'app-employee-attendence',
  templateUrl: './employee-attendence.component.html',
  styleUrls: ['./employee-attendence.component.css'],
})
export class EmployeeAttendenceComponent implements OnInit {
  attendanceList: any[] = [];
  employeeDropdown: any[] = [];
  departmentDropdown: any[] = [];
  departmentID: string = '';

  // Stats
  attendancePercentage: number = 0;
  absentPercentage: number = 0;
  fullDayCount: number = 0;
  absentCount: number = 0;
  groupedEmployee: any;

  // Filters


  selectedDate = new Date();
  formattedDate = ''

  isFactoryManager: boolean = false;
  isSupervisor: boolean = false;
  supervisor: any = {
    id: '',
    name: '',
  };
  filterForm: FormGroup;
  isLoading: boolean = false;

  constructor(
    private apiService: ServiceService,
    private methodService: ApiService,
    private fb: FormBuilder,
    private commonfn: CommonFunctionsService,
    private route: Router
  ) {
    this.filterForm = this.fb.group({
      month: [new Date()],
      selectedEmployee: [''],
      selectedDepartment: [''],
    });
  }


  onDateChange(date: Date) {
    const formatted = moment(date).format('YYYY-MM');
    this.formattedDate = formatted;
    this.fetchReportData();
  }
  private routerSubscription: any;
  private nextUrl: string | null = null;

  ngOnInit(): void {
    const savedState = this.commonfn.getFilterFormState();
    if (savedState) {
      this.filterForm.patchValue(savedState);
    }
    this.formattedDate = moment(this.filterForm.controls['month'].value).format('YYYY-MM');
    this.isFactoryManager =
      localStorage.getItem('userTypecon')?.toUpperCase() === 'FACTORY_MANAGER';
    this.fetchEmployees();
    this.fetchDepartments();
    this.routerSubscription = this.route.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.nextUrl = event.url;
      }
    });
  }


  // Data fetching methods
  fetchEmployees(searchValue?: string): void {
    if (this.isFactoryManager) {
      this.filterForm.controls['selectedDepartment'].setValue(
        'UMM AL QUWAIN FACTORY'
      );
    }

    this.apiService
      .ViewAllEmployeefilter(
        `?department=${this.filterForm.controls['selectedDepartment'].value || ''
        }`
      )
      .subscribe({
        next: (response) => {
          this.employeeDropdown = response.data;
          const savedState = this.commonfn.getFilterFormState();
          if (this.isFactoryManager) {
            this.departmentID = this.employeeDropdown[0]?.department_id || '';
          } else if (savedState) {
            this.departmentID = this.employeeDropdown[0]?.department_id || '';
          }
          const supervisor = {
            id: localStorage.getItem('headDep_id'),
            name: localStorage.getItem('headDep_name'),
          };
          if (
            supervisor.id &&
            supervisor.name &&
            supervisor.id !== 'undefined' &&
            supervisor.name !== 'undefined'
          ) {
            this.supervisor.id = supervisor.id
            this.supervisor.name = supervisor.name;
            this.isSupervisor = true;
          } else {
            this.supervisor.id = ""
            this.supervisor.name = "";
            this.isSupervisor = false;
          }
          this.fetchReportData();
        },
        error: (err) => console.error('Error fetching employees:', err),
      });
  }

  fetchDepartments(): void {
    this.apiService.departmentDropdown().subscribe({
      next: (response) => (this.departmentDropdown = response.data),
      error: (err) => console.error('Error fetching departments:', err),
    });
  }

  fetchReportData(): void {
    this.isLoading = true;
    const employeeId = this.filterForm.controls['selectedEmployee'].value || '';

    const params = `?month_filter=${this.formattedDate}&department_id=${this.departmentID}&employee_id=${employeeId}&factory_department_id=${this.supervisor.id}`;

    this.methodService
      .get(endPoints.viewEmployeeAttendance + '/employee_list/admin', params)
      .subscribe({
        next: (response) => {
          this.isLoading = false;
          this.attendanceList = response.data || [];

          this.calculateAttendanceStats();

          this.groupedEmployee = this.commonfn.groupAttendanceByEmployee(
            this.attendanceList
          );
        },
        error: (err) => {
          this.isLoading = false;
          console.error('Error fetching attendance:', err)
        }
      });
  }

  // Filter handlers
  onDepartmentChange(event: any): void {

    if (event) {
      this.fetchEmployees(event?.department_name);
      this.departmentID = event?.department_id;
    } else {
      this.departmentID = '';
      this.filterForm.controls['selectedEmployee'].setValue('');
      this.fetchEmployees('');
    }
    this.fetchReportData();
  }

  onEmployeeChange(event: any): void {
    this.fetchReportData();
  }

  // Stats calculation
  calculateAttendanceStats(): void {
    if (!this.attendanceList.length) {
      this.resetStats();
      return;
    }

    const totalDays = this.attendanceList.length;
    this.fullDayCount = this.attendanceList.filter(
      (item) => item.attendance_status?.toLowerCase() === 'present'
    ).length;

    this.absentCount = this.attendanceList.filter(
      (item) => item.attendance_status?.toLowerCase() === 'absent'
    ).length;

    this.attendancePercentage = Math.round(
      (this.fullDayCount / totalDays) * 100
    );
    this.absentPercentage = Math.round((this.absentCount / totalDays) * 100);
  }

  private resetStats(): void {
    this.attendancePercentage = 0;
    this.absentPercentage = 0;
    this.fullDayCount = 0;
    this.absentCount = 0;
  }

  stats: any = {};

  exportExcel(c: any) {
    const sheetData: any[][] = [];

    c.forEach((employee: any) => {
      // Heading for each employee
      sheetData.push([`Employee: ${employee.employee_name}`]);

      // Column headers
      sheetData.push([
        'Date',
        'Department',
        'Work In',
        'Break Out',
        'Break In',
        'Work Out',
        'Attendance Status',
        'Adjustment',
        'Leave Type',
        'Leave Status',
      ]);

      // Attendance rows
      employee.attendance.forEach((a: any) => {
        // debugger
        sheetData.push([
          a.date,
          employee.department,
          a.work_in,
          a.break_out,
          a.break_in,
          a.work_out,
          a.attendance_status,
          a.has_adjustment,
          a.leave_type,
          a.leave_status,
        ]);
      });

      // Empty row for spacing
      sheetData.push([]);
    });

    this.commonfn.exportMultipleSheetsToExcel(
      [
        {
          sheetName: 'Employee Attendance',
          data: sheetData,
          format: 'aoa', // <-- specify format as AOA
        },
      ],
      'Employee_Attendance_Report.xlsx'
    );
  }


  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    console.log('Navigating to:', this.nextUrl);
    if (this.nextUrl?.includes('/admin/employee-attendence-detail')) {
      // Save filter form state before navigating away
      this.commonfn.saveFilterFormState(this.filterForm.value);
    }else{
      this.commonfn.saveFilterFormState(null);
    }
  }
}
